__turbopack_context__.v({
  "content": "mantineModal-module-scss-module__y26s0q__content",
  "header": "mantineModal-module-scss-module__y26s0q__header",
  "title": "mantineModal-module-scss-module__y26s0q__title",
});
